import type { DocMigration } from "../docMigration";

// Round degrees to 2 decimal places so that we don't end up with weird angles like 359.99999999999994
const radianToDegree = (rad: number): number => Math.round(rad * (180 / Math.PI) * 100) / 100;

const migration: DocMigration = {
  maxSchemaVersion: "0.0.513",
  description: "Convert annotation template instance rotation from radians to degrees",
  apply(json: any) {
    const annotationTable = json.annotation ?? {};
    json.annotation = annotationTable;
    for (const annotationId of Object.keys(annotationTable)) {
      const annotation = annotationTable[annotationId];
      if (annotation.type === "TEMPLATE_INSTANCE") {
        annotation.rotation = radianToDegree(annotation.rotation ?? 0);
      }
    }
    return json;
  },
};

export default migration;
